import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {ActionButtonsContainer} from "./ActionButtons.styles";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {Tooltip} from "antd";

const ActionButtons = () => {
    const {t} = useTranslation(["pools"]);
    const history = useHistory();

    return (
        <ActionButtonsContainer>
            <Tooltip title={t("tooltips.newPoolRegion", {ns: "pools"})}>
                <CustomButton
                    type="primary"
                    data-testid="createNewPoolButton"
                    onClick={() => history.push("/pools/new")}
                    icon={<PlusOutlined />}
                >
                    {t("actions.newPoolregion", {ns: "pools"})}
                </CustomButton>
            </Tooltip>
        </ActionButtonsContainer>
    );
};

export default ActionButtons;
